import * as React from 'react'
import PropTypes from 'prop-types'

import Analytics from '../../../utils/Analytics'
import { CTALink, CTAButtonContainer } from './styles'

export default function CTAButton({
  children,
  ctaLink,
  ctaVariant = false,
  ctaAnalytics = 'Clicked_Builder CTA',
  backgroundColor = 'coral',
  useFullWidth = false,
  fontSize = 'medium',
}) {
  const finalBkgColor = backgroundColor || 'coral' // Possible that Builder passes null circumventing default prop value - this guards against it
  const fontSizeMap = {
    small: '14px',
    medium: '16px',
    large: '18px',
    xlarge: '20px',
  }
  const finalFontSize = fontSizeMap[fontSize] || '16px'

  return (
    <CTAButtonContainer
      ctaVariant={ctaVariant}
      bkgColor={finalBkgColor}
      onClick={() => Analytics.track(ctaAnalytics)}
      useFullWidth={useFullWidth}
      fontSize={finalFontSize}
    >
      <CTALink to={ctaLink} ctaVariant={ctaVariant} bkgColor={backgroundColor}>
        {children}
      </CTALink>
    </CTAButtonContainer>
  )
}

CTAButton.propTypes = {
  ctaLink: PropTypes.string,
  ctaVariant: PropTypes.string,
  children: PropTypes.node,
  ctaAnalytics: PropTypes.string,
  backgroundColor: PropTypes.string,
  useFullWidth: PropTypes.bool,
  fontSize: PropTypes.string,
}
